import { Button, Dialog, Typography } from '@mui/material';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import Flex from '@Components/Bases/Flex';

type DeleteModalProps = {
  topic: string;
  opened: boolean;
  close: () => void;
  confirm: () => void;
};

const DeleteModal = ({ topic, opened, close, confirm }: DeleteModalProps) => {
  return (
    <Dialog open={opened} onClose={close} maxWidth="xs">
      <Flex p={2} gap={2} borderBottom="1px solid rgba(0, 0, 0, 0.12)">
        <AssignmentLateOutlinedIcon
          style={{ fontSize: 32 }}
          color={'primary'}
        />
        <Flex flexDirection={'column'} gap={1}>
          <Typography fontWeight={'bold'} fontSize={16}>
            ยืนยันการลบข้อมูล
          </Typography>
          <Typography>
            ท่านต้องการลบ “{topic}” ใช่หรือไม่ หากใช่กรุณากดยืนยัน
          </Typography>
        </Flex>
      </Flex>
      <Flex gap={2} p={1} justifyContent="flex-end">
        <Button variant="contained" color="inherit" onClick={close}>
          ยกเลิก
        </Button>
        <Button onClick={confirm}>ยืนยัน</Button>
      </Flex>
    </Dialog>
  );
};

export default DeleteModal;
